
import { Component, Mixins, Prop } from 'vue-property-decorator';
import DarkThemeInfoMixin from '~common-mixins/DarkThemeInfoMixin';

@Component
export default class GroupEditableItem extends Mixins(DarkThemeInfoMixin) {
    @Prop({ default: false }) isDisabled!: boolean;
    @Prop({ default: false }) valid!: boolean;
    @Prop({ default: false }) isCreator!: boolean;
    @Prop({ default: '' }) groupName!: string;

    get validValue() {
        return this.valid;
    }
    set validValue(value: boolean) {
        this.$emit('update:valid', value);
    }
    get groupNameValue() {
        return this.groupName;
    }
    set groupNameValue(value: string) {
        this.$emit('update:groupName', value);
    }
}
